"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundPurchaseInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundPurchaseInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundPurchaseInit, _super);
    function FundPurchaseInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金购买页面初始化';
        _this.code = '106010';
        _this.desc = '基金购买页面初始化';
        _this.requestParams = new zl_1.FundPurchaseInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundPurchaseInit;
}(service_1.BaseService));
exports.FundPurchaseInit = FundPurchaseInit;
//# sourceMappingURL=fundPurchaseInit.js.map